module.exports = __webpack_public_path__ + "components/flag/static/square/af-3d4dea26b8863d62853fd4b9ab7db8de.svg";